import template from './sendEmail.html';
import './style.scss';

export default {
  template,
  bindings: {
    familyId: '<',
    isWorkbench: '<',
    loanId: '<',
    quoteId: '<',
    emailToEdit: '<',
    onBack: '&',
    modalInstance: '<',
  },
  controller: 'SendEmailComponentCtrl',
};
